import { useEffect } from 'react';
import type { ReactNode } from 'react';
import { useMainContext } from '../MainContext';
import Layout from './Layout';
import PageLayoutProvider from './provider';

type PageProps = {
  children: ReactNode;
  fillHeight?: boolean;
  scrollable?: boolean;
};

export default function Page({ children, fillHeight = false, scrollable = false }: PageProps) {
  const { setScrollable } = useMainContext();

  useEffect(() => {
    setScrollable(scrollable);
    return () => setScrollable(false);
  }, [scrollable, setScrollable]);

  return (
    <PageLayoutProvider>
      <Layout fillHeight={fillHeight}>{children}</Layout>
    </PageLayoutProvider>
  );
}
